import React from "react";
import NavBar from "../NavBar";
import Footer from "../Footer";
import EmailVerificationView from "./EmailVerificationView";

function VerifyEmailMain() {
  return (
    <div>
      {/*Add title and metadata */}
      <title>Change Password</title>
      <meta name="robots" content="noindex"></meta>

      {/*navbar*/}
      <NavBar />
      {/* Verify Email body */}
      <EmailVerificationView />
      {/* Footer */}
      <Footer />
    </div>
  );
}

export default VerifyEmailMain;
